@if (machines) {
    <div class="hdmui hdmui-m-0 sign-off hdmui-container">
        <header>
            <mat-toolbar class="sign-off__header">
                <h2>{{ 'DC.END_SHIFT_DIALOG.TITLE' | translate }}</h2>
            </mat-toolbar>
        </header>
        <section class="hdmui-content sign-off__content">
            @if (config$ | async; as config) {
                <mat-stepper [linear]="true" (selectionChange)="actionButtonHandle($event)">
                    <ng-template matStepperIcon="edit">
                        <mat-icon class="sign-off__done_icon" svgIcon="hdmui:hook"></mat-icon>
                    </ng-template>
                    @if (config.operations) {
                        <mat-step
                            [label]="'DC.SIGN_OFF_DIALOG.OPERATIONS.TITLE' | translate"
                            [stepControl]="dialogForm.controls[SignOffDialogStep.OPERATIONS]"
                            [editable]="true"
                            [state]="SignOffDialogStep.OPERATIONS"
                        >
                            <data-terminal-sign-off-operations
                                [userId]="dialogData.userId"
                                [signOffMachines]="(machinesToSignOff$ | async) || []"
                                (dataChange)="onOperationStateChange($event)"
                                (isValid)="setStepValidity(SignOffDialogStep.OPERATIONS, $event)"
                            ></data-terminal-sign-off-operations>
                        </mat-step>
                    }
                    @if (config.timeTransfer) {
                        <mat-step
                            [label]="'DC.PURE_TIME.SUBMIT_TIMES' | translate"
                            [stepControl]="dialogForm.controls[SignOffDialogStep.TIME_TRANSFER]"
                            [editable]="true"
                            [state]="SignOffDialogStep.TIME_TRANSFER"
                        >
                            <data-terminal-sign-off-time-transfer
                                #timeTransferComponent
                                [unsubmittedTimeEntries]="unsubmittedTimeEntries"
                                [signOffMachines]="(machinesToSignOff$ | async) || []"
                                (stateChange)="onTimeTransferStateChange($event)"
                            ></data-terminal-sign-off-time-transfer>
                        </mat-step>
                    }
                    @if (config.summary) {
                        <mat-step
                            [label]="'DC.SIGN_OFF_DIALOG.SUMMARY.TITLE' | translate"
                            [stepControl]="dialogForm.controls[SignOffDialogStep.SUMMARY]"
                            [editable]="true"
                            [state]="SignOffDialogStep.SUMMARY"
                        >
                            <data-terminal-sign-off-summary
                                [signOffMachines]="(machinesToSignOff$ | async) || []"
                            ></data-terminal-sign-off-summary>
                        </mat-step>
                    }
                </mat-stepper>
            }
        </section>
        <footer class="sign-off__action-buttons">
            <button mat-stroked-button (click)="onCancelClick()">{{ 'DC.SIGN_OFF_DIALOG.CANCEL' | translate }}</button>
            <div>
                <button
                    mat-stroked-button
                    matStepperPrevious
                    (click)="onPreviousClick()"
                    [disabled]="isPreviousButtonDisable"
                >
                    {{ 'DC.SIGN_OFF_DIALOG.PREVIOUS' | translate }}
                </button>
                <button mat-flat-button (click)="onNextClick()" [disabled]="isActionButtonDisable">
                    {{ 'DC.END_SHIFT_DIALOG.' + actionButtonText | translate }}
                </button>
            </div>
        </footer>
    </div>
}
